import { Component, Input, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { GRouteWorkOrdersService } from '../../../../../../../app/features/g-route/services/route-work-order.service';
import { GtrakAuthService } from '../../../../../../../app/features/authentication/services/gtrak-auth.service';
import { NewDeliveryModel } from '../../../../../../../app/features/g-route/models/new-delivery.model';
import { QueryResult } from '../../../../../../common/rest-api/models/query-result';
import {CommonService} from '../../../../../../common/services/common.service'

@Component({
  selector: 'app-garment-new-deliveries-page',
  templateUrl: 'garment-new-deliveries.page.html',
  styleUrls: [
     './garment-new-deliveries.page.scss',
     '../../../../styles/g-route.styles.scss'
  ]
})
export class NewDeliveriesPage implements ViewWillEnter, OnInit {

    currentRoute: string;
    stopName: string;
    routeDate: Date;
    Url:string;
    showOpen: boolean = false;
    showNew: boolean = true;

    newDeliveries: NewDeliveryModel[] = [];
    openDeliveries: NewDeliveryModel[] = [];
    loaded: boolean = false;
    routeStopName: string = "";
    breadcrumbs=[]

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: GtrakAuthService,
        private commonService:CommonService,
        private routeWorkOrdersService: GRouteWorkOrdersService
    ) { 
        this.currentRoute = null;
    }

    ngOnInit(): void {
        this.loaded=false;
        this.currentRoute = this.router.url;
    
        this.stopName = this.route.snapshot.paramMap.get('id');

        this.routeDate = this.authService.user.routeDate;

        this.routeStopName = localStorage.getItem('routeStopName');
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+  this.stopName});
        this.getNewDeliveries();
    }

    ionViewWillEnter(): void {
        
    }

    async getNewDeliveries(): Promise<void> {
        const forDateStr= this.commonService.getDateOnly(this.routeDate);
        this.newDeliveries = await this.routeWorkOrdersService.getNewDeliveryList(this.stopName, forDateStr);
        //go through each new delivery and if the work order delivery date is null push it to the open deliveries array
       if(this.newDeliveries!=null){
        this.newDeliveries.forEach((Delivery) => {
            if (Delivery.workOrder.deliveryDate == null &&( Delivery.workOrder.state ==1||Delivery.workOrder.state ==2||Delivery.workOrder.state ==3 )) {
                this.openDeliveries.push(Delivery);
            }
        });

        //now go through open deliveries and remove them from the new deliveries array
        this.newDeliveries = this.newDeliveries.filter((newDelivery) => {
            return newDelivery.workOrder.deliveryDate != null;
        });
    }
        this.loaded = true;
    }
    async getNewDeliveries1(): Promise<void> {
        this.newDeliveries = await this.routeWorkOrdersService.getNewDeliveryList1(this.stopName, this.routeDate);
        //go through each new delivery and if the work order delivery date is null push it to the open deliveries array
        this.newDeliveries.forEach((Delivery) => {
            if (Delivery.workOrder.deliveryDate == null &&( Delivery.workOrder.state ==1||Delivery.workOrder.state ==2||Delivery.workOrder.state ==3 )) {
                this.openDeliveries.push(Delivery);
            }
        });

        //now go through open deliveries and remove them from the new deliveries array
        this.newDeliveries = this.newDeliveries.filter((newDelivery) => {
            return newDelivery.workOrder.state === 4 && newDelivery.workOrder.deliveryDate != null;
        });

    }

    changeView(): void {
        this.showOpen = !this.showOpen;
        this.showNew = !this.showNew;
    }

}